import React from 'react';
import { OnboardingStepper } from 'components/OnboardingStepper/OnboardingStepper';
import { Styles } from './styles';
import { Logo } from 'assets/svgs/Logo';

type OnboardingWrapperProps = {
  currentStep: number;
};

export const OnboardingWrapper: React.FC<OnboardingWrapperProps> = ({ children, currentStep }) => {
  return (
    <Styles.Wrapper>
      <Styles.Header>
        <Logo width="97px" color="deepBlue" />
      </Styles.Header>
      <OnboardingStepper steps={5} currentStep={currentStep} />
      <Styles.Content>{children}</Styles.Content>
    </Styles.Wrapper>
  );
};
